import Decimal from 'decimal.js';

type PricingTier = {
	min: number;
	unitPrice: number;
};

export const creditBundles = [500, 1000, 5000, 20000, 100000];
export const MIN_CREDIT_BUY_AMOUNT = 500;
export const PRICE_DECIMALS = 2;
const VAT = new Decimal(0.255);

export const pricingTiers: PricingTier[] = [
	{ min: 100000, unitPrice: 0.054 },
	{ min: 50000, unitPrice: 0.059 },
	{ min: 20000, unitPrice: 0.069 },
	{ min: 5000, unitPrice: 0.079 },
	{ min: 2500, unitPrice: 0.084 },
	{ min: 500, unitPrice: 0.089 },
];

export const formatCurrency = (value: number): string =>
	(Math.round((value + Number.EPSILON) * 100) / 100).toFixed(2);

export function calculateTransactionPricing(transactions: number): {
	unitPrice: number;
	totalCost: number;
} {
	if (transactions < MIN_CREDIT_BUY_AMOUNT) {
		throw new Error('Minimum 500 transactions required.');
	}

	const tier = pricingTiers.find(t => transactions >= t.min);
	if (!tier) throw new Error('Pricing tier not found.');

	const totalCost = new Decimal(transactions)
		.times(tier.unitPrice)
		.toNumber();

	return {
		unitPrice: tier.unitPrice,
		totalCost,
	};
}

export function getPriceWithoutVat(unitCount: number): number {
	const priceWithoutVat = calculateTransactionPricing(unitCount).totalCost;
	return priceWithoutVat;
}

export function getVat(priceWithoutVat: number): number {
	const price = new Decimal(priceWithoutVat);
	const vatAmount = price.mul(VAT);
	return vatAmount.toNumber();
}

export function getPriceWithoutVatRounded(unitCount: number): number {
	const priceWithoutVat = getPriceWithoutVat(unitCount);
	return new Decimal(priceWithoutVat)
		.toDecimalPlaces(PRICE_DECIMALS)
		.toNumber();
}

export function getVatRounded(priceWithoutVat: number): number {
	const vat = getVat(priceWithoutVat);
	return new Decimal(vat).toDecimalPlaces(PRICE_DECIMALS).toNumber();
}
